import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import { CasReactHookFormDialog } from 'src/compass/shared/components';

import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { IGeneralObjectType } from 'src/compass/site/util';
import { getSelectSchema } from 'src/compass/shared/schemas';
import { RHFTouchpointFrequencySelect } from './TouchpointFrequencySelect';

const Schema = Yup.object().shape({
  frequency: getSelectSchema('Frequency'),
});

type Props = {
  employeeId: number;
  onClose: VoidFunction;
};

export default function AssignAllFrequencyDialog({ employeeId, onClose }: Props) {
  const navigate = useNavigate();
  
  const { mutate } = useUpdateMutation({
    url: 'Utilities/EntityTouchpoint/AssignAll',
    params: { employeeId },
    onSuccess: (response) => {
      onSuccessEnqueueSnackbar(response);
      onClose();
      navigate('/riskManagement/customers/Touchpoints');
    },
  });

  const onSubmit = (payload: IGeneralObjectType) => mutate(payload);

  return (
    <CasReactHookFormDialog
      open
      title="Assign all Unassigned to..."
      submitButtonLabel="Assign"
      onClose={onClose}
      onSubmit={onSubmit}
      schema={Schema}
    >
      <RHFTouchpointFrequencySelect label="Frequency" name="frequency" />
    </CasReactHookFormDialog>
  );
}
